module.exports = __webpack_public_path__ + "static/media/thank-you-icon.ecdc9452.gif";